import React, { useEffect, useRef, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { roles } from '../data';
import { roleIcons } from '../iconMap';
import Brand from './Brand';
import LanguageToggle from './LanguageToggle';

function AppHeader({ user, language, setLanguage, onRoleChange, t }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const close = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  return (
    <header className="app-header">
      <div className="mobile-brand">
        <Brand compact />
      </div>
      <div className="header-spacer" />
      <LanguageToggle
        language={language}
        onChange={setLanguage}
        label={t.language}
        english={t.english}
        spanish={t.spanish}
      />
      <div className="account" ref={menuRef}>
        <button
          type="button"
          className="account-trigger"
          onClick={() => setOpen((value) => !value)}
          aria-label={t.accountMenu}
          aria-expanded={open}
        >
          <span className="avatar avatar-small">{user.avatar}</span>
          <span className="account-copy">
            <strong>{user.name}</strong>
            <small>{t[user.role]}</small>
          </span>
          <SafeIcon icon={FiIcons.FiChevronDown} />
        </button>

        {open && (
          <div className="account-menu">
            <div className="account-menu-title">
              <small>{t.signedInAs}</small>
              <strong>{user.name}</strong>
            </div>
            <p>{t.switchDemoRole}</p>
            {roles.map((role) => (
              <button
                type="button"
                className={user.role === role ? 'current-role' : ''}
                onClick={() => {
                  onRoleChange(role);
                  setOpen(false);
                }}
                key={role}
              >
                <SafeIcon icon={roleIcons[role]} />
                <span>{t[role]}</span>
                {user.role === role && <SafeIcon icon={FiIcons.FiCheck} />}
              </button>
            ))}
          </div>
        )}
      </div>
    </header>
  );
}

export default AppHeader;